import { Output } from "valibot";

import Attachment from "components/MessageBubble/Attachment";
import { SupportTicketInfoSchema } from "components/SonicBot/schemas";
import { Literals } from "shared/types";

import { EmailNotificationInfo } from "./components/EmailNotificationInfo";
import { TicketAttribute } from "./components/TicketAttribute";
import { TicketStatus } from "./components/TicketStatus";

type Props = {
  ticketInfo: Output<typeof SupportTicketInfoSchema>;
  copyTexts: Literals;
};

function TicketInfo(props: Props) {
  const { ticketInfo, copyTexts } = props;
  return (
    <div className="w-full overflow-y-scroll bg-white px-4 py-6">
      <TicketStatus copyTexts={copyTexts} />
      <div className="mt-6 flex flex-col gap-5">
        <EmailNotificationInfo email={ticketInfo.email} copyTexts={copyTexts} />
        <TicketAttribute
          title={copyTexts.ticketIdText}
          value={`#${ticketInfo.ticket_id}`}
        />
        <TicketAttribute
          title={copyTexts.fullNameText}
          value={ticketInfo.name}
        />
        <TicketAttribute title={copyTexts.titleText} value={ticketInfo.title} />
        {ticketInfo.description && (
          <TicketAttribute
            title={copyTexts.descriptionText}
            value={ticketInfo.description}
          />
        )}
        {(ticketInfo?.attachments?.length || 0) > 0 && (
          <div className="flex flex-col gap-1 rounded-lg text-sm">
            <p className="font-semibold">{copyTexts.attachedText}</p>
            <div className="flex flex-col gap-1">
              {ticketInfo?.attachments?.map(attachment => (
                <Attachment
                  url={attachment.url}
                  fileName={attachment.file_name}
                  mimetype={attachment.mimetype}
                  fileSize={attachment.file_size}
                  variant="light"
                  isFullScreen={true}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TicketInfo;
